module.exports = __webpack_public_path__ + "static/media/pc_icon_download.76c7efbb.svg";